<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Edit Invoice</span>
    <a-tag slot="extra" class="m-text-bold">Revision No
      {{
        this.collectData.detil_account
        ? this.collectData.detil_account[0].revision_no
        : 0
      }}
    </a-tag>
    <a-spin :spinning="pageLaoding">
      <a-steps :current="current" status="process">
        <a-step title="Information" />
        <a-step title="Detail Account" />
        <a-step title="Detail Deliverable" />
        <a-step title="Detail PPN" />
      </a-steps>
      <div class="steps-content flex-1">
        <keep-alive>
          <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
        </keep-alive>
      </div>
    </a-spin>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next" :disabled="pageLaoding">Next</a-button>
        <a-button :loading="btnLoading" v-if="current == steps.length - 1" :disabled="pageLaoding" type="primary"
          @click="validate">Save</a-button>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Informasi from "./steps/Informasi.vue";
import DetailAccount from "./steps/DetailAccount.vue";
import DetailProduct from "./steps/ProductDetail.vue";
import DetailInvoice from "./steps/DetailInvoice.vue";
import moment from "moment";
import _ from "lodash";

export default {
  name: "EditAP",
  props: ["id", "type"],
  mixins: [CurrencyFormat],
  components: {
    Informasi,
    DetailAccount,
    DetailProduct,
    DetailInvoice,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "DetailAccount",
          content: "DetailAccount",
        },
        {
          title: "DetailProduct",
          content: "DetailProduct",
        },
        {
          title: "DetailInvoice",
          content: "DetailInvoice",
        },
      ],
      mode: "Edit",
      collectData: {},
      templistData: {},
      postData: new FormData(),
      postJson: {},
      editData: {},
      btnLoading: false,
      pageLaoding: false,
      files: [],
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate"]),
    stepProps: function () {
      if (this.steps[this.current].content === "Informasi") {
        return {
          information: this.collectData.information,
          combo_pimpro: this.collectData.combo_pimpro,
          mode: this.mode
        };
      } else if (this.steps[this.current].content === "DetailAccount") {
        return {
          detil_account: this.collectData.detil_account,
          combo_bank: this.collectData.combo_bank,
          combo_currency: this.collectData.combo_currency,
          customer: this.collectData.customer,
          bkm: this.collectData.detil_bkm,
          bkmcombo: this.collectData.bkm,
          mode: this.mode
        };
      } else if (this.steps[this.current].content === "DetailProduct") {
        return {
          detil_product: this.collectData.detil_product,
          detil_termin_list: this.collectData.termin_dtl,
          currency: this.collectData.detil_account[0].project_currency,
          mode: this.mode
        };
      } else if (this.steps[this.current].content === "DetailInvoice") {
        return {
          detil_invoice: this.collectData.detil_invoice,
          currency: this.collectData.detil_account[0].project_currency,
          mode: this.mode
        };
      }
      return true;
    },
    stepRef: function () {
      let val = "";
      if (this.steps[this.current].content === "Informasi") {
        val = "refInformasi";
      } else if (this.steps[this.current].content === "DetailAccount") {
        val = "refDetailAccount";
      } else if (this.steps[this.current].content === "DetailProduct") {
        val = "refDetailProduct";
      } else if (this.steps[this.current].content === "DetailInvoice") {
        val = "refDetailInvoice";
      }
      return val;
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    moment,
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "DetailAccount") {
        this.$refs.refDetailAccount.handleRef();
      } else if (this.steps[this.current].content === "DetailProduct") {
        this.$refs.refDetailProduct.handleRef();
      } else if (this.steps[this.current].content === "DetailInvoice") {
        this.$refs.refDetailInvoice.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    fetch() {
      this.pageLaoding = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "akuntansi/ar_akuntansi/edit_ar_acc",
        params: {
          tlc: this.getAuth.username,
          id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = response.data;
          this.collectData.detil_account[0]["customer_id"] = response.data.customer_id;
          this.collectData.detil_account[0]["bkm_id"] = response.data.bkm_id ? response.data.bkm_id : undefined;
          this.pageLaoding = false;
        })
        .catch((err) => {
          this.pageLaoding = false;
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    validate() {
      this.$refs.refDetailInvoice.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.information[0].description =
          value.informasi.description;
        this.collectData.information[0].sktd_ppn_no =
          value.informasi.sktd_ppn_no;
        this.collectData.information[0].pimpro = value.informasi.pimpro;
        this.collectData.information[0].periode_end_dt =
          value.informasi.periode_end_dt;
        this.collectData.information[0].periode_start_dt =
          value.informasi.periode_start_dt;
        this.collectData.information[0].invoice_to = value.informasi.invoice_to;
        this.current++;
      } else if (this.steps[this.current].content === "DetailAccount") {
        this.collectData.detil_account[0].bank_account =
          value.detil_account.bank_account;
        this.collectData.detil_account[0].efaktur_no =
          value.detil_account.efaktur_no;
        this.collectData.detil_account[0].exchange_rate =
          value.detil_account.exchange_rate;
        this.collectData.detil_account[0].invoice_date =
          value.detil_account.invoice_date;
        this.collectData.detil_account[0].ppn = value.detil_account.ppn;
        this.collectData.detil_account[0].project_currency =
          value.detil_account.project_currency;
        this.collectData.detil_account[0].project_value =
          value.detil_account.project_value;
        this.collectData.detil_account[0].revision_no =
          value.detil_account.revision_no;
        this.collectData.detil_account[0].upload_document_support =
          value.detil_account.upload_document_support;
        this.collectData.detil_account[0].value_ar =
          value.detil_account.value_ar;
        this.collectData.detil_account[0].work_name =
          value.detil_account.work_name;
        this.collectData.detil_account[0].new_upload = value.new_upload;
        this.collectData.detil_account[0].bkm_id = value.detil_account.bkm_id;
        this.collectData.detil_account[0].customer_id = value.detil_account.customer_id;

        _.forEach(this.collectData.detil_product, (data, index) => {
          this.collectData.detil_product[index].currency =
            value.detil_account.project_currency;
        });

        this.collectData.detil_bkm = value.detil_account.listBKM
        this.current++;
      } else if (this.steps[this.current].content === "DetailProduct") {
        this.collectData.detil_product = JSON.parse(
          JSON.stringify(value.detil_product)
        );
        this.current++;
      } else if (this.steps[this.current].content === "DetailInvoice") {
        this.collectData.detil_invoice[0] = value.detil_invoice;
        this.confirmMessage("confirm-save");
      }
    },
    setSubmitForm() {
      this.postData = new FormData();
      this.postData.append("id", this.id);
      this.postData.append("tlc", this.getAuth.username);
      this.postData.append("kode", this.collectData.information[0].kode);
      this.postData.append(
        "contract_no",
        this.collectData.information[0].no_sales_contract
      );
      this.postData.append(
        "description",
        this.collectData.information[0].description
      );
      this.postData.append(
        "work_name",
        this.collectData.information[0].description
      );
      this.postData.append("pimpro", this.collectData.information[0].pimpro);
      this.postData.append(
        "periode_start",
        this.collectData.information[0].periode_start_dt
      );
      this.postData.append(
        "periode_end",
        this.collectData.information[0].periode_end_dt
      );
      this.postData.append(
        "invoice_to",
        this.collectData.information[0].invoice_to
      );
      this.postData.append(
        "sktd_ppn",
        this.collectData.information[0].sktd_ppn_no
      );

      this.postData.append(
        "revision_no",
        this.collectData.detil_account[0].revision_no
      );
      this.postData.append(
        "bank_account",
        this.collectData.detil_account[0].bank_account
      );
      this.postData.append(
        "project_currency",
        this.collectData.detil_account[0].project_currency
      );
      this.postData.append(
        "exchange_rate",
        this.collectData.detil_account[0].exchange_rate
      );
      this.postData.append(
        "project_value",
        this.collectData.detil_account[0].project_value
      );
      this.postData.append("ppn", this.collectData.detil_account[0].ppn);
      this.postData.append(
        "invoice_date",
        moment(this.collectData.detil_account[0].invoice_date).format(
          "MM/DD/YYYY"
        )
      );
      this.postData.append(
        "efaktur_no",
        this.collectData.detil_account[0].efaktur_no
      );

      this.postData.append("customer", this.collectData.information[0].customer_nm);
      this.postData.append("bkm", this.collectData.detil_account[0].bkm_id);

      this.postData.append("type_ppn", this.collectData.detil_invoice[0].type_ppn);
      if (this.collectData.detil_invoice[0].value_tax)
        this.postData.append("value_tax", this.collectData.detil_invoice[0].value_tax);
      this.postData.append("upload_document_tax", this.collectData.detil_invoice[0].push);

      // this.postData.append(
      //   "ppn_sktd",
      //   this.collectData.detil_invoice[0].ppn_sktd
      // );
      // this.postData.append(
      //   "ppn_dipungut",
      //   this.collectData.detil_invoice[0].ppn_dipungut
      // );
      // this.postData.append(
      //   "ppn_memungut",
      //   this.collectData.detil_invoice[0].ppn_memungut
      // );
      // this.postData.append(
      //   "ppn_migas",
      //   this.collectData.detil_invoice[0].ppn_migas
      // );
      // this.postData.append("pph22_15", this.collectData.detil_invoice[0].pph22_15);
      // this.postData.append("fee_lain", this.collectData.detil_invoice[0].fee_lain);
      // this.postData.append("taktis", this.collectData.detil_invoice[0].taktis);

      let ifile = [];
      if (this.collectData.detil_account[0].new_upload.length > 0) {
        if (!this.collectData.detil_account[0].new_upload[0].exist) {
          ifile = this.collectData.detil_account[0].new_upload[0];
        }
      }
      this.postData.append("upload_file_support", ifile);

      this.collectData.detil_product.forEach((data, index) => {
        this.postData.append(
          `detil_product[${index}][id_sc_dtl_product]`,
          data.id_sc_dtl_product
        );
        this.postData.append(
          `detil_product[${index}][produk_name]`,
          data.product_nm
        );
        this.postData.append(`detil_product[${index}][work_name]`, data.product_nm);
        this.postData.append(`detil_product[${index}][id_sc_dtl_invoice]`, data.id_sc_dtl_invoice);
        this.postData.append(`detil_product[${index}][pn]`, data.product_pn);
        this.postData.append(`detil_product[${index}][note]`, data.note);
        this.postData.append(`detil_product[${index}][unit]`, data.unit);
        this.postData.append(`detil_product[${index}][qty]`, data.qty);
        this.postData.append(
          `detil_product[${index}][unit_price]`,
          data.unit_price
        );
      });

      this.collectData.detil_bkm.forEach((data, index) => {
        if (data.id_ar_acc_bkm)
          this.postData.append(`detil_bkm[${index}][id_ar_acc_bkm]`, data.id_ar_acc_bkm);
        this.postData.append(`detil_bkm[${index}][bank_account]`, data.bank);
        this.postData.append(`detil_bkm[${index}][project_currency]`, data.currency);
        this.postData.append(`detil_bkm[${index}][exchange_rate]`, data.exchange_rate);
        this.postData.append(`detil_bkm[${index}][bkm_id]`, data.bkm);
      });
    },
    submit() {
      this.setSubmitForm();
      this.btnLoading = true;
      let method = "";
      let data = "";
      let url = "";

      method = "post";
      data = this.postData;
      url = this.$serviceUrl + "akuntansi/Ar_akuntansi/edit_ar_acc";

      axios({
        method: method,
        url: url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.btnLoading = false;
          this.$router.push({ name: "arAccounting-index" });
          this.displayMessageValue("success-other", response.data.message);
        })
        .catch((err) => {
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            //console.log(responses);
            this.displayMessageValue("error", responses);
          }
          this.btnLoading = false;
        });
    },
  },
  mounted() {
    Event.$on("emitChild", this.valueFromChild);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("emitChild", this.valueFromChild);
    Event.$off("confirmMessageReturn", this.submit);
  },
};
</script>

<style></style>
